/** id/type for the transient ghost node previewed during a connection drop. */
export const CONNECTION_PREVIEW_NODE_ID = 'connection-preview-node'
export const CONNECTION_PREVIEW_NODE_TYPE = 'CONNECTION_PREVIEW'

/** Fixed skeleton size shown before a picker option is hovered. */
export const CONNECTION_PREVIEW_SKELETON_WIDTH = 136
export const CONNECTION_PREVIEW_SKELETON_HEIGHT = 60

/**
 * z-index for the dragged preview edge and its ghost node, so they always sit
 * above existing nodes/edges (which top out at React Flow's selection elevation
 * of 1000) while a connection is being dropped.
 */
export const CONNECTION_PREVIEW_Z_INDEX = 2000
